export default __webpack_public_path__ + "static/media/feature-5.3bd0f92c.svg";